import { RootState } from "shared/redux/store";
import { UserPermissionsState } from "./userPermissionsState";

export const selectUserPermissions = (state: RootState): UserPermissionsState =>
  state.userPermissions;
